import React from 'react'
import styled from 'styled-components'

import ColumnGridPanel from 'components/ColumnGridPanel'

import ConnectedStatusIcon from 'pages/shared/ConnectedStatusIcon'

import { color } from 'styles/colors'
import { FRIENDLY_NAMES } from 'helpers/reportFriendlyNames'
import { degreesFahrenheit, relativeHumidity } from 'helpers/formatters'

type ReportProps = {
  systemMode: string
  operatingStatus: string
  outdoorTemperature: string
  emergencyHeatEnabled: boolean
  dehumidifierStatus: string
  ventilatorStatus: string
  quietModeAvailable: boolean
  quietModeActive: boolean
  relativeHumidity: number
}

type Props = {
  report: ReportProps
  hasZones: boolean
}

const systemStatusIcons = {
  'OFF': 'off.png',
  'SYSTEM_COOLING': 'cooling.png',
  'SYSTEM_HEATING': 'heating.svg',
  'DEFROST': 'heating-defrost.svg',
  'FAN_RUNNING': 'fan.svg'
}

const Status = ({ report, hasZones = false }: Props) => {
  return (
    <S.Container>
      {!hasZones &&
        <div>
          <span>System Mode: </span> <S.Status>{report.systemMode ? report.systemMode : '--'}</S.Status>
        </div>
      }
      <S.StatusRow>
        <span>Status:</span>
        {
          report.operatingStatus &&
          <S.Status>{FRIENDLY_NAMES[report.operatingStatus.replace('SYSTEM_', '')]}</S.Status>
        }
        { report.operatingStatus && systemStatusIcons[report.operatingStatus] &&
          <S.StatusIcon src={`/img/status-icons/${systemStatusIcons[report.operatingStatus]}`} alt="system status" />
        }
        {report.emergencyHeatEnabled && <S.StatusIcon src="/img/status-icons/emergency-heat.png" alt="emergency-heat" /> }
        {report.dehumidifierStatus && report.dehumidifierStatus.toLowerCase() !== 'not installed' && <S.StatusIcon src="/img/status-icons/dehumidifying.svg" alt="dehumidifying-on" /> }
        {report.ventilatorStatus && report.ventilatorStatus.toLowerCase() !== 'not installed' && report.ventilatorStatus.toLowerCase() !== 'off' && <S.StatusIcon src="/img/status-icons/ventilator.svg" alt="ventilator-on" /> }
        {report.quietModeAvailable && report.quietModeActive && <S.StatusIcon src="/img/status-icons/quitemode.svg" alt="quitemode-enabled" /> }
      </S.StatusRow>
      {hasZones &&
        <>
          <S.OutdoorTemp><span>Outdoor Temp: </span>{degreesFahrenheit(report.outdoorTemperature) || '--'}</S.OutdoorTemp>
          <S.RelativeHumidity><span>Relative Humidity: </span>{relativeHumidity(report.relativeHumidity) || '--'}</S.RelativeHumidity>
        </>
      }
    </S.Container>
  )
}

export default Status

const S = {
  ConnectedStatusIcon: styled(ConnectedStatusIcon)`
    margin-left: 5px;
    width: 16px;
    height: 16px;
  `,
  OutdoorTemp: styled.div`
  `,
  RelativeHumidity: styled.div`
    margin-top: 5px;
    font-size: 1rem;
  `,
  StatusRow: styled.div`
    display: flex;
    align-items: center;
    margin-top: 5px;
    gap: 5px;
  `,
  Status: styled.span`
    color: ${color('LastUpdatedText')};
    text-transform: capitalize;
    margin-left: 5px;
`,
  StatusIcon: styled.img`
    margin-left: 5px;
    width: 25px;
    height: 25px;
  `,
  Item: styled(ColumnGridPanel.Column.Item)`
    grid-template-columns: 45% 55%;
  `,
  Container: styled.div`
    display: flex;
    flex-direction: column;
    margin: 0 0 10px 0;
    font-size: 14px;
    line-height: 1.5;

    span {
      margin-bottom: 5px;
      font-weight: 600;
    }
  `
}
